<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/asegurador">Asegurador</router-link>
            > Detalle
          </div>
        </div>
        <div class="col-1">
          <span
            class="material-symbols-outlined"
            style="font-size: 32px; color: blue; cursor: pointer"
            @click="showModalHelp = true"
          >
            help
          </span>
        </div>
      </div>
    </div>	
    <hr>
<!-- Modal -->
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idAsegurador" class="form-label">IdAsegurador</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAsegurador" name="idAsegurador" v-model="datoAsegurador.idAsegurador" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoAsegurador.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoAsegurador.tipo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarAsegurador" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

    <!-- Estructura de Tabs -->
    <div class="tabs">
      <button
        class="tablink"
        @click="showTable = 'tarifarioCreado'"
        :class="{ 'active-tab': showTable === 'tarifarioCreado' }"
      >
        <span class="material-symbols-outlined"> person </span>
        Tarifarios creados
      </button>
      <button
        class="tablink"
        @click="showTable = 'tarifarioUtilizado'"
        :class="{ 'active-tab': showTable === 'tarifarioUtilizado' }"
      >
        <span class="material-symbols-outlined"> person </span>
        Tarifarios utilizados
      </button>
      <button
        class="tablink"
        @click="showTable = 'detalleTarifario'"
        :class="{ 'active-tab': showTable === 'detalleTarifario' }"
      >
        <span class="material-symbols-outlined"> person </span>
        Detalle de Tarifarios
      </button>
    </div>

    <div v-if="showTable === 'tarifarioCreado'">
      <Tarifario
      ></Tarifario>
    </div>
    <div v-if="showTable === 'tarifarioUtilizado'">
      <TarifaAseg
      ></TarifaAseg>
    </div>
    <div v-if="showTable === 'detalleTarifario'">
      <Tarifa
      ></Tarifa>
    </div>
  
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import Tarifario from "@/views/forms/Tarifario.vue";
import TarifaAseg from "@/views/forms/TarifaAseg.vue";
import Tarifa from "@/views/forms/Tarifa.vue";

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer, Tarifario, TarifaAseg, Tarifa
  },
  data () {
    return {
      aseguradors : [],
      datoAsegurador : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      modalWindow: true,
      p_idAsegurador: 0,
      showTable: "",
    }
  },
  mounted () {
    this.p_idAsegurador = this.$route.params.p_idasegurador
    this.getData()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods : {
   getData() {
      api.get('/vwaseguradors/'+this.p_idAsegurador)
        .then(response => {
          this.datoAsegurador = response.data;
        })
        .catch(error => {
         console.error('Error al obtener datos de la persona:', error);
        });
    },
    validarForm(){
      const requiredFields = [
        'nombre'
        ,'tipo'
      ];
      const requiredFieldsText = [
        'nombre'
        ,'tipo'
      ];
      return validarForm(this.datoAsegurador, requiredFields, requiredFieldsText);
    },
    async guardarAsegurador(){
      if(this.validarForm() === 1){
        try {
          await api.post('/aseguradors', this.datoAsegurador)
          swal("Correcto!", "Asegurador creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
  },
}
</script>
<style src="@/assets/css/tabs.css" scoped></style>